import gql from 'graphql-tag';
export default gql`
  mutation sendWetSignatureEmail($applicationId: String!, $wetSignatureObjName: String!, $email: String!) {
    sendWetSignatureEmail(applicationId: $applicationId, wetSignatureObjName: $wetSignatureObjName, email: $email) {
      url
    }
  }
`;
